import React from 'react';
import { IoFootball } from 'react-icons/io5';
import './Loader.css';

const Loader = ({ text = 'Loading...', fullscreen = true }) => {
  const containerClass = fullscreen
    ? 'loader-container fullscreen'
    : 'loader-container absolute';

  return (
    <div className={containerClass}>
      <div className="loader-content">
        <IoFootball className="football-icon" />
        {text && <div className="loader-text">{text}</div>}
      </div>
    </div>
  );
};

export default Loader;
